/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Ref } from 'preact/hooks';

/**
 * Return the dataset info of target element.
 * @param target
 * @param rootRef
 * @returns
 */
export function getElementData(rootRef: Ref<Element>, target: HTMLElement) {
  let currentTarget = target;

  while (currentTarget != rootRef.current) {
    const objectId = currentTarget.dataset['ojObject'];
    if (objectId) {
      return currentTarget.dataset;
    }
    currentTarget = currentTarget.parentElement!;
  }
  return null;
}

/**
 * Parses the groupIndex and ItemIndex from the fiven DOMStringMap.
 * @param infoMap
 */
export function parseInfo(infoMap: DOMStringMap) {
  return {
    groupIndex: infoMap['ojGroupIndex'] ? parseInt(infoMap['ojGroupIndex'], 10) : undefined,
    seriesIndex: infoMap['ojSeriesIndex'] ? parseInt(infoMap['ojSeriesIndex'], 10) : undefined
  };
}

/**
 * Returns the group or item info.
 * @param rootRef
 * @param event
 * @returns
 */
export function getInfo(rootRef: Ref<HTMLElement>, event: Event) {
  const elDomMap = getElementData(rootRef, event.target as HTMLElement);
  if (!elDomMap) {
    return;
  }

  return parseInfo(elDomMap);
}

/**
 * Prevent defaults and stops propagation of event.
 * @param event
 */
export function cancelEvent(event: Event) {
  event.preventDefault();
  event.stopPropagation();
}
